import { CCUtils } from "../../../../common/CCUtils"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { MakeVideoScreenTextConfig } from "../MakeVideoTypes"

export class MakeVideoScreenText {

    private text: Phaser.Text
    private current: MakeVideoScreenTextConfig

    constructor(private game: Phaser.Game) {
        this.step = {step: 0, edit: false}
    }

    get step(): MakeVideoScreenTextConfig {
        return this.current
    }

    set step(config: MakeVideoScreenTextConfig) {
        const { step, edit } = config
        if (step >= 0 && step < 7) {
            this.current = config
            this.setScreenText(step, edit)
        }
    }

    private setScreenText = (step: number, edit: boolean) => {
        let text: string
        switch (step) {
            case 0:
                text =
                    edit ? "Select another type of music, and then click “Next”. Otherwise, click “Next” to skip to Step 2."
                         : "The first step is to choose the music for your video. Click on each type of music to preview it. " +
                            "Then click on the select button under the type of music you want for your video. Click \"Next\" to continue."
                break
            case 1:
                text =
                    edit ? "You can change the placement of your clips as many times as you want. " +
                            "Just drag the clip to a different numbered square or back up to one of the gray boxes. " +
                            "When you are done with your changes, click next."
                         : "The next step is to choose your video clips. Click on each clip to preview it, and then drag the clip down to the time line. " +
                            "You can change the placement of your clips as many times as you want. " +
                            "Just drag the clip to a different numbered square or back up to one of the gray boxes."
                break
            case 2:
                text =
                    edit ? "Click on a different title, or click \"Next\" to continue."
                         : "Next, you get to make your title screen. The first thing to do is choose your title. " +
                            "Click on the title you want and then click \"Next\"."
                break
            case 3:
                text = edit ? "Click on a new background, or click \"Next\" to continue." : "Now, choose your background and click “Next” to continue."
                break
            case 4:
                text = edit ? "Finally, play your edited video." : "Finally, play your video by clicking on the \"Play\" button."
                break
            default:
                throw new Error("Bad step number: " + step)
        }

        if (this.text) {
            this.text.destroy(true)
        }

        this.text = PhaserText.create(this.game, text, {
            debug: CCUtils.debug,
            wordWrapWidth: 0.85,
            fontPx: 20,
            x: Scale.x(0.1),
            y: Scale.y(0.119)
        })
        this.game.world.sendToBack(this.text)
    }
}
